import { getSafe } from "../../util/storeHelper";
export const isAnalyticsEnabled = (state) => getSafe(state, ["settings", "analytics", "enabled"], false);
